/**
 * Specifies what resource values are returned from the locstrings service.
 */
import officeStartResources from './output/OfficeStrings-Versioned/office-start-resources.json';
import searchMeControlResources from './output/OfficeStrings-Versioned/search-me-control-resources.json';
export function getDefaultResources(partnerResourceIdentifier) {
    if (partnerResourceIdentifier === void 0) { partnerResourceIdentifier = 'office-start-resources'; }
    if (partnerResourceIdentifier === 'search-me-control-resources') {
        return searchMeControlResources;
    }
    else {
        return officeStartResources;
    }
}
//# sourceMappingURL=getDefaultResources.js.map